var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThrana({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.174,
    height: 36.868,
    viewBox: "0 0 222.174 36.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "THRANA_XD_TO_GURU",
    "data-name": "THRANA XD TO GURU",
    transform: "translate(-12028 -7720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M1057.823,404.6a29.573,29.573,0,0,1-2.723,2.269",
    transform: "translate(11082.52 7317.473)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M1052.45,404.6a32.872,32.872,0,0,1-6.95,5.7",
    transform: "translate(11091.057 7317.473)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M1036.7,413.52a35.3,35.3,0,0,0,10.9-8.82",
    transform: "translate(11098.883 7317.385)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M1106.2,419.712a37.618,37.618,0,0,0,5.224-5.312",
    transform: "translate(11037.074 7308.758)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M1035.86,471a34.093,34.093,0,0,1-7.36,4.416",
    transform: "translate(11106.175 7258.422)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M1028.845,496.3a39.05,39.05,0,0,1-8.245,4.4",
    transform: "translate(11113.201 7235.922)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M1111.4,442.579a40.162,40.162,0,0,0,5.445-5.179",
    transform: "translate(11032.45 7288.303)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M1021.267,524.8a42.291,42.291,0,0,1-8.367,3.951",
    transform: "translate(11120.049 7210.576)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M1116.4,464.991a42.693,42.693,0,0,0,5.666-5.091",
    transform: "translate(11028.004 7268.293)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M1121.4,487.013a43.718,43.718,0,0,0,5.866-5.013",
    transform: "translate(11023.557 7248.639)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M1014.022,552.3a44.529,44.529,0,0,1-8.422,3.53",
    transform: "translate(11126.541 7186.12)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M1010.12,562.7a46.155,46.155,0,0,1-11.72,4.936",
    transform: "translate(11132.944 7176.87)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M1126.7,508.725a46.96,46.96,0,0,0,6.043-4.925",
    transform: "translate(11018.844 7229.252)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M1013.158,525.4A48.364,48.364,0,0,1,991.4,536.965",
    transform: "translate(11139.169 7210.042)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M1098.2,546.7a50.781,50.781,0,0,1-12,7.913",
    transform: "translate(11054.86 7191.1)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M993.154,628.1a50.432,50.432,0,0,1-8.754,2.667",
    transform: "translate(11145.395 7118.708)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M977.6,654.546a52.811,52.811,0,0,0,8.876-2.446",
    transform: "translate(11151.442 7097.364)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M1137.88,567.8a53.253,53.253,0,0,1-7.88,5.567",
    transform: "translate(11015.908 7172.335)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M1153.451,588.8a56.567,56.567,0,0,1-6.751,4.759",
    transform: "translate(11001.057 7153.659)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M1158.528,609.6a56.278,56.278,0,0,1-6.928,4.737",
    transform: "translate(10996.698 7135.161)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M1163.6,630.3a59.1,59.1,0,0,1-7.1,4.726",
    transform: "translate(10992.342 7116.752)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M1195.262,650.9q-1.926,1.444-3.962,2.745",
    transform: "translate(10961.393 7098.432)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M1228.253,671.3c-.221.155-.432.321-.653.476",
    transform: "translate(10929.11 7080.289)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M408.8,406.2h7.99v11.244h9.02V406.2h7.99v30.213h-7.99v-12h-9.02V436.4H408.8Z",
    transform: "translate(11657.293 7316.05)",
    fill: "#3c005a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M724.6,406.2h11.432c6.507,0,12.085,2.236,12.085,9.761,0,4.327-1.948,7.16-4.881,8.732l6.552,11.709h-8.92l-5.2-10.126H732.6V436.4h-7.99V406.2Zm10.879,13.756c3.165,0,4.836-1.394,4.836-4s-1.671-3.442-4.836-3.442H732.6v7.437Z",
    transform: "translate(11376.442 7316.05)",
    fill: "#3c005a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M1288.911,406.2h8.178l6.7,13.48c1.018,2.047,1.948,4.46,2.878,6.784h.188a107.2,107.2,0,0,1-1.018-11.521v-8.732h7.625v30.213h-8.178l-6.707-13.5c-1.018-2.047-1.948-4.46-2.877-6.784h-.188a111.765,111.765,0,0,1,1.018,11.521v8.732H1288.9l.011-30.191Z",
    transform: "translate(10874.594 7316.05)",
    fill: "#3c005a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M1617.822,404.6a29.572,29.572,0,0,1-2.722,2.269",
    transform: "translate(10584.495 7317.473)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M1612.45,404.6a32.872,32.872,0,0,1-6.95,5.7",
    transform: "translate(10593.032 7317.473)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M1596.7,413.52a35.3,35.3,0,0,0,10.9-8.82",
    transform: "translate(10600.858 7317.385)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M1666.2,419.712a37.611,37.611,0,0,0,5.224-5.312",
    transform: "translate(10539.05 7308.758)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M1595.86,471a34.093,34.093,0,0,1-7.36,4.416",
    transform: "translate(10608.15 7258.422)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M1588.845,496.3a39.046,39.046,0,0,1-8.245,4.4",
    transform: "translate(10615.177 7235.922)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M1671.4,442.579a40.154,40.154,0,0,0,5.445-5.179",
    transform: "translate(10534.425 7288.303)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M1581.267,524.8a42.278,42.278,0,0,1-8.367,3.951",
    transform: "translate(10622.024 7210.576)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M1676.4,464.991a42.686,42.686,0,0,0,5.667-5.091",
    transform: "translate(10529.979 7268.293)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M1681.4,487.013a43.725,43.725,0,0,0,5.866-5.013",
    transform: "translate(10525.531 7248.639)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M1574.022,552.3a44.527,44.527,0,0,1-8.422,3.53",
    transform: "translate(10628.517 7186.12)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M1570.12,562.7a46.157,46.157,0,0,1-11.72,4.936",
    transform: "translate(10634.92 7176.87)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M1686.7,508.725a46.96,46.96,0,0,0,6.043-4.925",
    transform: "translate(10520.818 7229.252)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M1573.158,525.4a48.365,48.365,0,0,1-21.758,11.565",
    transform: "translate(10641.145 7210.042)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M1658.2,546.7a50.782,50.782,0,0,1-12,7.913",
    transform: "translate(10556.837 7191.1)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M1553.154,628.1a50.427,50.427,0,0,1-8.754,2.667",
    transform: "translate(10647.37 7118.708)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M1537.6,654.546a52.809,52.809,0,0,0,8.876-2.446",
    transform: "translate(10653.418 7097.364)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M1697.88,567.8a53.226,53.226,0,0,1-7.88,5.567",
    transform: "translate(10517.884 7172.335)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M1713.451,588.8a56.568,56.568,0,0,1-6.751,4.759",
    transform: "translate(10503.032 7153.659)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M1718.528,609.6a56.278,56.278,0,0,1-6.928,4.737",
    transform: "translate(10498.675 7135.161)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M1723.6,630.3a59.089,59.089,0,0,1-7.1,4.726",
    transform: "translate(10494.316 7116.752)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M1755.262,650.9c-1.284.963-2.6,1.881-3.962,2.745",
    transform: "translate(10463.368 7098.432)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M1788.253,671.3c-.221.155-.431.321-.653.476",
    transform: "translate(10431.085 7080.289)",
    fill: "none",
    stroke: "#3c005a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_718_00000063613645723750214950000011787094592352611735_",
    transform: "translate(12028.002 7720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M96.45,388.192v7.171c-3.143-1.217-8.477-2.014-11.975-2.39v21.249h-7.99V392.907c-3.553.332-8.931,1.129-12.085,2.4v-7.171c4.549-1.572,11.631-2.335,16.368-2.269C85.261,385.912,92.1,386.676,96.45,388.192Z",
    transform: "translate(-64.4 -385.864)",
    fill: "#3c005a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5361",
    "data-name": "Group 5361",
    transform: "translate(12028 7728.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M80.658,494.978l-.974-.564A30.163,30.163,0,0,1,64.6,468.273l3.907-1.074c0,8.975,4.637,18.438,12.163,23.241,7.537-4.8,12.163-14.365,12.163-23.34l3.907,1.173a30.163,30.163,0,0,1-15.084,26.14Z",
    transform: "translate(-64.6 -467.1)",
    fill: "#3c005a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrana);
export default __webpack_public_path__ + "static/media/thrana.d516ce9ba84ee1282c0ac5bd19d10482.svg";
export { ForwardRef as ReactComponent };